import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-success-screen',
  templateUrl: './success-screen.component.html',
  styleUrls: ['./success-screen.component.css']
})
export class SuccessScreenComponent {

  screenHeight = window.screen.height - 271; // 1058
  minHeight = 'min-height: ' + this.screenHeight + 'px !important'

  screenHeight2 = window.screen.height - 630; // 428
  minHeight2 = 'min-height: ' + this.screenHeight2 + 'px !important'

  @Output() states = new EventEmitter<{state:boolean}>();
  submit() {
    this.states.emit({state:true})
  }
}
